import { Ranges } from 'api/System/types'
import { createSelector } from 'reselect'
import type { State } from 'store/types'

const selectDomain = (state: State) => state.datePicker

export const selectTypeAnalysis = createSelector([selectDomain], ({ typeAnalysis }) => typeAnalysis)
export const selectClosedPeriod = createSelector([selectDomain], ({ closedPeriod }) => closedPeriod || Ranges.WEEK)
export const selectIsOpen = createSelector([selectDomain], ({ isOpen }) => isOpen)
export const selectDateCurrent = createSelector([selectDomain], ({ dateCurrent }) => dateCurrent)
